import React from 'react';
import { Grid } from '@mui/material';
import { SelectV, InputV2, AutocompleteV, DatePickerPod, InputCurrency } from 'components';
import { DateTimePicker, TimePicker, DatePicker } from 'components/LegacyPickers';
import { FILTER_TYPES } from './services/Services';

export const FilterFieldsGenerator = ({
  localFilters,
  setCurrentFilter,
  pushFilter,
  checkValidDateRange,
  control,
}) => {
  const getFilterFields = () => {
    let fields = [];
    for (const field of localFilters) {
      switch (field.filterType) {
        case FILTER_TYPES.autocomplete:
          fields.push(
            <Grid item xs={12} md={6} key={fields.keyName}>
              <AutocompleteV
                name={`${field?.keyName}:${FILTER_TYPES.autocomplete}`}
                key={`${field?.keyName}:${FILTER_TYPES.autocomplete}`}
                forceValue={field?.value}
                value={field?.value}
                placeholder={field?.placeholder ?? 'جستجو و انتخاب کنید...'}
                label={field?.label}
                preventAddCustomOption
                getOptionSelected={(option, value) => option?.value === value?.value}
                onChangeValue={(v) => {
                  const newCurrentFilter = {
                    ...field,
                    value: v,
                  };
                  setCurrentFilter(newCurrentFilter);
                  pushFilter(newCurrentFilter);
                }}
                {...field?.filterProps}
              />
            </Grid>,
          );
          break;
        case FILTER_TYPES.select:
          fields.push(
            <Grid item xs={12} md={6} key={fields.keyName}>
              <SelectV
                label={field?.label}
                name={`${field?.keyName}:${FILTER_TYPES.select}`}
                key={`${field?.keyName}:${FILTER_TYPES.select}`}
                options={field?.filterProps?.options ?? []}
                fullWidth
                forceValue={field?.value}
                value={field?.value}
                onChangeFunc={(v, e) => {
                  const newCurrentFilter = {
                    ...field,
                    value: e?.target?.value,
                  };
                  setCurrentFilter(newCurrentFilter);
                  pushFilter(newCurrentFilter);
                }}
                defaultValue={''}
                {...field?.filterProps}
              />
            </Grid>,
          );
          break;
        case FILTER_TYPES.selectRange:
          fields.push(
            <Grid item xs={12} key={fields.keyName}>
              <Grid item xs={12}>
                <span>{field?.title}</span>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <SelectV
                      label={field?.label?.start}
                      name={`${field?.keyName}:${FILTER_TYPES.selectRange}:start`}
                      key={`${field?.keyName}:${FILTER_TYPES.selectRange}:start`}
                      options={field?.filterProps?.start?.options ?? []}
                      fullWidth
                      forceValue={field?.value?.start}
                      value={field?.value?.start}
                      onChangeFunc={(v, e) =>
                        setCurrentFilter({
                          ...field,
                          value: {
                            start: e?.target?.value,
                            end: field?.value?.end,
                          },
                        })
                      }
                      defaultValue=""
                      {...field?.filterProps?.start}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <SelectV
                      label={field?.label?.end}
                      name={`${field?.keyName}:${FILTER_TYPES.selectRange}:end`}
                      key={`${field?.keyName}:${FILTER_TYPES.selectRange}:end`}
                      options={field?.filterProps?.end?.options ?? []}
                      fullWidth
                      forceValue={field?.value?.end}
                      value={field?.value?.end}
                      onChangeFunc={(v, e) =>
                        setCurrentFilter({
                          ...field,
                          value: {
                            end: e?.target?.value,
                            start: field?.value?.start,
                          },
                        })
                      }
                      defaultValue=""
                      {...field?.filterProps?.end}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>,
          );
          break;
        case FILTER_TYPES.text:
          fields.push(
            <Grid item xs={12} md={6} key={fields.keyName}>
              <InputV2
                errors={{}}
                name={`${field?.keyName}:${FILTER_TYPES.text}`}
                key={`${field?.keyName}:${FILTER_TYPES.text}`}
                label={field?.label}
                fullWidth
                forceValue={field?.value || null}
                onChangeValue={(e) => {
                  if (e && e.persist) {
                    e.persist();
                  }
                  const newCurrentFilter = {
                    ...field,
                    value: field?.filterProps?.currency ? e : e?.target?.value,
                  };
                  setCurrentFilter(newCurrentFilter);
                  pushFilter(newCurrentFilter);
                }}
                // onBlur={pushFilter}
                defaultValue={null}
                {...field?.filterProps}
              />
            </Grid>,
          );
          break;
        case FILTER_TYPES.textRange:
          fields.push(
            <Grid item xs={12} key={fields.keyName}>
              <Grid item xs={12}>
                <span>{field?.title}</span>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    {field?.unit ? (
                      <InputCurrency
                        control={control}
                        errors={{}}
                        name={`${field?.keyName}:${FILTER_TYPES.textRange}:start`}
                        key={`${field?.keyName}:${FILTER_TYPES.textRange}:start`}
                        label={field?.label?.start}
                        fullWidth
                        forceValue={field?.value?.start}
                        onChangeValue={(e) => {
                          const newCurrentFilter = {
                            ...field,
                            value: {
                              start: field?.filterProps?.start?.currency ? e : e?.target?.value,
                              end: field?.value?.end,
                            },
                          };
                          setCurrentFilter(newCurrentFilter);
                          pushFilter(newCurrentFilter);
                          checkValidDateRange();
                        }}
                        onBlur={pushFilter}
                        defaultValue={''}
                        {...field?.filterProps?.start}
                      />
                    ) : (
                      <InputV2
                        control={control}
                        errors={{}}
                        name={`${field?.keyName}:${FILTER_TYPES.textRange}:start`}
                        key={`${field?.keyName}:${FILTER_TYPES.textRange}:start`}
                        label={field?.label?.start}
                        fullWidth
                        forceValue={field?.value?.start}
                        onChangeValue={(e) => {
                          const newCurrentFilter = {
                            ...field,
                            value: {
                              start: field?.filterProps?.start?.currency ? e : e?.target?.value,
                              end: field?.value?.end,
                            },
                          };
                          setCurrentFilter(newCurrentFilter);
                          pushFilter(newCurrentFilter);
                          checkValidDateRange();
                        }}
                        onBlur={pushFilter}
                        defaultValue={''}
                        {...field?.filterProps?.start}
                      />
                    )}
                  </Grid>
                  <Grid item xs={6}>
                    {field?.unit ? (
                      <InputCurrency
                        errors={{}}
                        name={`${field?.keyName}:${FILTER_TYPES.textRange}:end`}
                        key={`${field?.keyName}:${FILTER_TYPES.textRange}:end`}
                        label={field?.label?.end}
                        fullWidth
                        forceValue={field?.value?.end}
                        onChangeValue={(e) => {
                          const newCurrentFilter = {
                            ...field,
                            value: {
                              start: field?.value?.start,
                              end: field?.filterProps?.end?.currency ? e : e?.target?.value,
                            },
                          };
                          setCurrentFilter(newCurrentFilter);
                          pushFilter(newCurrentFilter);
                          checkValidDateRange();
                        }}
                        onBlur={pushFilter}
                        defaultValue={''}
                        {...field?.filterProps?.end}
                      />
                    ) : (
                      <InputV2
                        errors={{}}
                        name={`${field?.keyName}:${FILTER_TYPES.textRange}:end`}
                        key={`${field?.keyName}:${FILTER_TYPES.textRange}:end`}
                        label={field?.label?.end}
                        fullWidth
                        forceValue={field?.value?.end}
                        onChangeValue={(e) => {
                          const newCurrentFilter = {
                            ...field,
                            value: {
                              start: field?.value?.start,
                              end: field?.filterProps?.end?.currency ? e : e?.target?.value,
                            },
                          };
                          setCurrentFilter(newCurrentFilter);
                          pushFilter(newCurrentFilter);
                          checkValidDateRange();
                        }}
                        onBlur={pushFilter}
                        defaultValue={''}
                        {...field?.filterProps?.end}
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>,
          );
          break;
        case FILTER_TYPES.date:
          fields.push(
            <Grid item xs={12} md={6} key={fields.keyName}>
              <DatePickerPod
                label={field?.label}
                showAsterisk={
                  field?.filterProps?.rules?.includes('required') || field?.filterProps?.required
                }
              >
                <DatePicker
                  variant="inline"
                  name={`${field?.keyName}:${FILTER_TYPES.date}`}
                  key={`${field?.keyName}:${FILTER_TYPES.date}`}
                  autoOk
                  inputVariant="outlined"
                  showTodayButton
                  todayLabel="امروز"
                  okLabel="تایید"
                  cancelLabel="لغو"
                  clearLabel="پاک کردن"
                  labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
                  value={field?.value}
                  onChange={(e) => {
                    const newCurrentFilter = {
                      ...field,
                      value: e,
                    };

                    setCurrentFilter(newCurrentFilter);
                    pushFilter(newCurrentFilter);
                  }}
                  defaultValue={''}
                  {...field?.filterProps}
                />
              </DatePickerPod>
            </Grid>,
          );
          break;
        case FILTER_TYPES.dateRange:
          fields.push(
            <Grid item xs={12} key={fields.keyName}>
              <Grid item xs={12}>
                <span>{field?.title}</span>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <DatePickerPod
                      label={field?.label?.start}
                      showAsterisk={
                        field?.filterProps?.start?.rules?.includes('required') ||
                        field?.filterProps?.start?.required
                      }
                    >
                      <DatePicker
                        variant="inline"
                        name={`${field?.keyName}:${FILTER_TYPES.dateRange}:start`}
                        key={`${field?.keyName}:${FILTER_TYPES.dateRange}:start`}
                        autoOk
                        inputVariant="outlined"
                        showTodayButton
                        todayLabel="امروز"
                        okLabel="تایید"
                        cancelLabel="لغو"
                        clearLabel="پاک کردن"
                        labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
                        value={field?.value?.start}
                        onError={(error) => {
                          return null;
                        }}
                        onChange={(e) => {
                          const newCurrentFilter = {
                            ...field,
                            value: {
                              start: e,
                              end: field?.value?.end,
                            },
                          };

                          setCurrentFilter(newCurrentFilter);
                          pushFilter(newCurrentFilter);
                          checkValidDateRange();
                        }}
                        defaultValue={''}
                        {...field?.filterProps?.start}
                      />
                    </DatePickerPod>
                  </Grid>
                  <Grid item xs={6}>
                    <DatePickerPod
                      label={field?.label?.end}
                      showAsterisk={
                        field?.filterProps?.end?.rules?.includes('required') ||
                        field?.filterProps?.end?.required
                      }
                    >
                      <DatePicker
                        variant="inline"
                        name={`${field?.keyName}:${FILTER_TYPES.dateRange}:end`}
                        key={`${field?.keyName}:${FILTER_TYPES.dateRange}:end`}
                        autoOk
                        inputVariant="outlined"
                        showTodayButton
                        todayLabel="امروز"
                        okLabel="تایید"
                        cancelLabel="لغو"
                        clearLabel="پاک کردن"
                        labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
                        value={field?.value?.end}
                        onChange={(e) => {
                          const newCurrentFilter = {
                            ...field,
                            value: {
                              end: e,
                              start: field?.value?.start,
                            },
                          };

                          setCurrentFilter(newCurrentFilter);
                          pushFilter(newCurrentFilter);
                          checkValidDateRange();
                        }}
                        defaultValue={''}
                        {...field?.filterProps?.end}
                      />
                    </DatePickerPod>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>,
          );
          break;
        case FILTER_TYPES.month:
          fields.push(
            <Grid item xs={12} key={fields.keyName}>
              <Grid item xs={12}>
                <span>{field?.title}</span>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <DatePickerPod
                      label={field?.label?.start}
                      showAsterisk={
                        field?.filterProps?.start?.rules?.includes('required') ||
                        field?.filterProps?.start?.required
                      }
                    >
                      <DatePicker
                        variant="inline"
                        name={`${field?.keyName}:${FILTER_TYPES.month}:start`}
                        key={`${field?.keyName}:${FILTER_TYPES.month}:start`}
                        autoOk
                        inputVariant="outlined"
                        showTodayButton
                        todayLabel="امروز"
                        okLabel="تایید"
                        cancelLabel="لغو"
                        clearLabel="پاک کردن"
                        labelFunc={(date) => (date ? date.format('jYYYY/jMM') : '')}
                        value={field?.value?.start}
                        onError={(error) => {
                          return null;
                        }}
                        onChange={(e) => {
                          const newCurrentFilter = {
                            ...field,
                            value: {
                              start: e,
                              end: field?.value?.end,
                            },
                          };

                          setCurrentFilter(newCurrentFilter);
                          pushFilter(newCurrentFilter);
                          checkValidDateRange();
                        }}
                        defaultValue={''}
                        {...field?.filterProps?.start}
                      />
                    </DatePickerPod>
                  </Grid>
                  <Grid item xs={6}>
                    <DatePickerPod
                      label={field?.label?.end}
                      showAsterisk={
                        field?.filterProps?.end?.rules?.includes('required') ||
                        field?.filterProps?.end?.required
                      }
                    >
                      <DatePicker
                        variant="inline"
                        name={`${field?.keyName}:${FILTER_TYPES.month}:end`}
                        key={`${field?.keyName}:${FILTER_TYPES.month}:end`}
                        autoOk
                        inputVariant="outlined"
                        showTodayButton
                        todayLabel="امروز"
                        okLabel="تایید"
                        cancelLabel="لغو"
                        clearLabel="پاک کردن"
                        labelFunc={(date) => (date ? date.format('jYYYY/jMM') : '')}
                        value={field?.value?.end}
                        onChange={(e) => {
                          const newCurrentFilter = {
                            ...field,
                            value: {
                              end: e,
                              start: field?.value?.start,
                            },
                          };

                          setCurrentFilter(newCurrentFilter);
                          pushFilter(newCurrentFilter);
                          checkValidDateRange();
                        }}
                        defaultValue={''}
                        {...field?.filterProps?.end}
                      />
                    </DatePickerPod>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>,
          );
          break;

        case FILTER_TYPES.year:
          fields.push(
            <Grid item xs={12} md={6} key={field.keyName}>
              <DatePickerPod label={field.label}>
                <DatePicker
                  variant="inline"
                  autoOk
                  inputVariant="outlined"
                  views={['year']}
                  openTo="year"
                  labelFunc={(date) => (date ? date.format('jYYYY') : '')}
                  value={field.value}
                  onChange={(e) => {
                    const newCurrentFilter = {
                      ...field,
                      value: e, // بدون jMoment اضافه
                    };

                    setCurrentFilter(newCurrentFilter);
                    pushFilter(newCurrentFilter);
                    checkValidDateRange();
                  }}
                  {...field.filterProps}
                />
              </DatePickerPod>
            </Grid>,
          );
          break;

        case FILTER_TYPES.dateTime:
          fields.push(
            <Grid item xs={12} md={6} key={fields.keyName}>
              <DatePickerPod
                label={field?.label}
                showAsterisk={
                  field?.filterProps?.rules?.includes('required') || field?.filterProps?.required
                }
              >
                <DateTimePicker
                  variant="inline"
                  name={`${field?.keyName}:${FILTER_TYPES.textRange}`}
                  key={`${field?.keyName}:${FILTER_TYPES.textRange}`}
                  autoOk
                  inputVariant="outlined"
                  showTodayButton
                  todayLabel="امروز"
                  okLabel="تایید"
                  cancelLabel="لغو"
                  clearLabel="پاک کردن"
                  labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD HH:mm') : '')}
                  value={field?.value}
                  onChange={(e) => {
                    const newCurrentFilter = {
                      ...field,
                      value: e,
                    };
                    setCurrentFilter(newCurrentFilter);
                    pushFilter(newCurrentFilter);
                    checkValidDateRange();
                  }}
                  defaultValue=""
                  {...field?.filterProps}
                />
              </DatePickerPod>
            </Grid>,
          );
          break;
        case FILTER_TYPES.dateTimeRange:
          fields.push(
            <Grid item xs={12} key={fields.keyName}>
              <Grid item xs={12}>
                <span>{field?.title}</span>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <DatePickerPod
                      label={field?.label?.start}
                      showAsterisk={
                        field?.filterProps?.start?.rules?.includes('required') ||
                        field?.filterProps?.start?.required
                      }
                    >
                      <DateTimePicker
                        variant="inline"
                        name={`${field?.keyName}:${FILTER_TYPES.dateTimeRange}:start`}
                        key={`${field?.keyName}:${FILTER_TYPES.dateTimeRange}:start`}
                        autoOk
                        inputVariant="outlined"
                        showTodayButton
                        todayLabel="امروز"
                        okLabel="تایید"
                        cancelLabel="لغو"
                        clearLabel="پاک کردن"
                        labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD HH:mm') : '')}
                        value={field?.value?.start}
                        onChange={(e) => {
                          const newCurrentFilter = {
                            ...field,
                            value: {
                              start: e,
                              end: field?.value?.end,
                            },
                          };

                          setCurrentFilter(newCurrentFilter);
                          pushFilter(newCurrentFilter);
                          checkValidDateRange();
                        }}
                        defaultValue={''}
                        {...field?.filterProps?.start}
                      />
                    </DatePickerPod>
                  </Grid>
                  <Grid item xs={6}>
                    <DatePickerPod
                      label={field?.label?.end}
                      showAsterisk={
                        field?.filterProps?.end?.rules?.includes('required') ||
                        field?.filterProps?.end?.required
                      }
                    >
                      <DateTimePicker
                        variant="inline"
                        name={`${field?.keyName}:${FILTER_TYPES.dateTimeRange}:end`}
                        key={`${field?.keyName}:${FILTER_TYPES.dateTimeRange}:end`}
                        autoOk
                        inputVariant="outlined"
                        showTodayButton
                        todayLabel="امروز"
                        okLabel="تایید"
                        cancelLabel="لغو"
                        clearLabel="پاک کردن"
                        labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD HH:mm') : '')}
                        value={field?.value?.end}
                        onChange={(e) => {
                          const newCurrentFilter = {
                            ...field,
                            value: {
                              end: e,
                              start: field?.value?.start,
                            },
                          };

                          setCurrentFilter(newCurrentFilter);
                          pushFilter(newCurrentFilter);
                          checkValidDateRange();
                        }}
                        defaultValue={''}
                        {...field?.filterProps?.end}
                      />
                    </DatePickerPod>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>,
          );
          break;
        case FILTER_TYPES.time:
          fields.push(
            <Grid item xs={12} md={6} key={fields.keyName}>
              <DatePickerPod
                label={field?.label}
                showAsterisk={
                  field?.filterProps?.rules?.includes('required') || field?.filterProps?.required
                }
              >
                <TimePicker
                  variant="inline"
                  name={`${field?.keyName}:${FILTER_TYPES.time}`}
                  key={`${field?.keyName}:${FILTER_TYPES.time}`}
                  autoOk
                  inputVariant="outlined"
                  showTodayButton
                  todayLabel="اکنون"
                  okLabel="تایید"
                  cancelLabel="لغو"
                  clearLabel="پاک کردن"
                  labelFunc={(date) => (date ? date.format('HH:mm') : '')}
                  value={field?.value}
                  onChange={(e) => {
                    const newCurrentFilter = {
                      ...field,
                      value: e,
                    };

                    setCurrentFilter(newCurrentFilter);
                    pushFilter(newCurrentFilter);
                  }}
                  defaultValue={''}
                  {...field?.filterProps}
                />
              </DatePickerPod>
            </Grid>,
          );
          break;
        case FILTER_TYPES.timeRange:
          fields.push(
            <Grid item xs={12} key={fields.keyName}>
              <Grid item xs={12}>
                <span>{field?.title}</span>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <DatePickerPod
                      label={field?.label?.start}
                      showAsterisk={
                        field?.filterProps?.start?.rules?.includes('required') ||
                        field?.filterProps?.start?.required
                      }
                    >
                      <TimePicker
                        variant="inline"
                        name={`${field?.keyName}:${FILTER_TYPES.timeRange}:start`}
                        key={`${field?.keyName}:${FILTER_TYPES.timeRange}:start`}
                        autoOk
                        inputVariant="outlined"
                        showTodayButton
                        todayLabel="اکنون"
                        okLabel="تایید"
                        cancelLabel="لغو"
                        clearLabel="پاک کردن"
                        labelFunc={(date) => (date ? date.format('HH:mm') : '')}
                        value={field?.value?.start}
                        onChange={(e) => {
                          const newCurrentFilter = {
                            ...field,
                            value: {
                              start: e,
                              end: field?.value?.end,
                            },
                          };

                          setCurrentFilter(newCurrentFilter);
                          pushFilter(newCurrentFilter);
                        }}
                        defaultValue={''}
                        {...field?.filterProps?.start}
                      />
                    </DatePickerPod>
                  </Grid>
                  <Grid item xs={6}>
                    <DatePickerPod
                      label={field?.label?.end}
                      showAsterisk={
                        field?.filterProps?.end?.rules?.includes('required') ||
                        field?.filterProps?.end?.required
                      }
                    >
                      <TimePicker
                        variant="inline"
                        name={`${field?.keyName}:${FILTER_TYPES.timeRange}:end`}
                        key={`${field?.keyName}:${FILTER_TYPES.timeRange}:end`}
                        autoOk
                        inputVariant="outlined"
                        showTodayButton
                        todayLabel="اکنون"
                        okLabel="تایید"
                        cancelLabel="لغو"
                        clearLabel="پاک کردن"
                        labelFunc={(date) => (date ? date.format('HH:mm') : '')}
                        {...(field?.value?.start ? { minDate: field?.value?.start } : {})}
                        value={field?.value?.end}
                        onChange={(e) => {
                          const newCurrentFilter = {
                            ...field,
                            value: {
                              end: e,
                              start: field?.value?.start,
                            },
                          };

                          setCurrentFilter(newCurrentFilter);
                          pushFilter(newCurrentFilter);
                        }}
                        defaultValue={''}
                        {...field?.filterProps?.end}
                      />
                    </DatePickerPod>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>,
          );
          break;
        default:
          break;
      }
    }
    return fields;
  };

  return getFilterFields();
};

export default FilterFieldsGenerator;
